var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMastercard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.7465 11.6133H9.17261C8.51353 11.6133 7.97925 12.1476 7.97925 12.8066V23.9199C7.97925 24.579 8.51353 25.1133 9.17261 25.1133H27.7465C28.4055 25.1133 28.9398 24.579 28.9398 23.9199V12.8066C28.9398 12.1476 28.4055 11.6133 27.7465 11.6133Z",
    fill: "#F9F9F9",
    stroke: "#EDEDED",
    strokeWidth: 0.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18536_3377)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.4244 21.2788H16.9089V15.4473H20.4244V21.2788Z",
    fill: "#FF5F00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1322 18.3635C17.1317 17.8019 17.2696 17.2476 17.5354 16.7424C17.8013 16.2373 18.1882 15.7947 18.6667 15.448C18.0741 15.018 17.3623 14.7507 16.6129 14.6764C15.8634 14.6022 15.1064 14.7241 14.4284 15.0282C13.7504 15.3323 13.1788 15.8063 12.7789 16.3961C12.3789 16.9859 12.1668 17.6677 12.1667 18.3635C12.1669 19.0592 12.379 19.7408 12.779 20.3305C13.1789 20.9202 13.7504 21.3942 14.4283 21.6983C15.1062 22.0023 15.8631 22.1243 16.6125 22.0501C17.3618 21.976 18.0735 21.7087 18.6662 21.279C18.1878 20.9322 17.801 20.4895 17.5353 19.9844C17.2695 19.4793 17.1317 18.925 17.1322 18.3635Z",
    fill: "#EB001B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.1667 18.3635C25.1667 19.0593 24.9546 19.741 24.5546 20.3308C24.1547 20.9206 23.5831 21.3946 22.9051 21.6987C22.2271 22.0028 21.4701 22.1247 20.7206 22.0505C19.9712 21.9763 19.2594 21.7089 18.6667 21.279C19.6011 20.6 20.2013 19.5465 20.2013 18.3635C20.2013 17.1805 19.6011 16.127 18.6667 15.448C19.2594 15.018 19.9712 14.7507 20.7206 14.6764C21.4701 14.6022 22.2271 14.7241 22.9051 15.0282C23.5831 15.3323 24.1547 15.8063 24.5546 16.3961C24.9546 16.9859 25.1667 17.6677 25.1667 18.3635Z",
    fill: "#F79E1B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18536_3377"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 12,
    fill: "white",
    transform: "translate(12.1667 12.3633)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercard);
export default __webpack_public_path__ + "static/media/mastercard.f5fdc58ded69426dad21346bc1b187dd.svg";
export { ForwardRef as ReactComponent };